import React from "react";

export function ChannelScenarioIllus() {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="120" height="120" rx="10" fill="#E8F1FB" />
      <path d="M18 88 L62 68 L106 88 L62 108 Z" fill="#C4D4E8" />
      <path d="M28 82 L62 66 L96 82 L62 98 Z" fill="#D8E4F2" />
      <rect x="38" y="52" width="48" height="32" rx="3" fill="#4A7FD4" transform="skewY(-12)" />
      <rect x="42" y="48" width="40" height="28" rx="2" fill="#5B8FE0" />
      <rect x="46" y="52" width="32" height="20" rx="1" fill="#E8F4FF" />
      <rect x="50" y="58" width="10" height="8" rx="1" fill="#93C5FD" />
      <rect x="62" y="56" width="12" height="10" rx="1" fill="#60A5FA" />
      <circle cx="54" cy="64" r="3" fill="#3B82F6" />
      <rect x="72" y="70" width="18" height="14" rx="2" fill="#FDE68A" transform="rotate(-8 81 77)" />
      <rect x="24" y="74" width="16" height="20" rx="2" fill="#F1F5F9" transform="rotate(6 32 84)" />
      <line x1="28" y1="78" x2="36" y2="78" stroke="#CBD5E1" strokeWidth="1.5" />
      <line x1="28" y1="82" x2="34" y2="82" stroke="#CBD5E1" strokeWidth="1.5" />
      <rect x="78" y="76" width="3" height="14" rx="1" fill="#64748B" transform="rotate(-20 79.5 83)" />
    </svg>
  );
}

export function ChannelMeetingIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M8 44 L32 30 L56 44 L32 58 Z" fill="#BFDBFE" />
      <path d="M14 40 L32 30 L50 40 L32 50 Z" fill="#93C5FD" />
      <rect x="22" y="18" width="20" height="14" rx="2" fill="#3B82F6" />
      <rect x="24" y="20" width="16" height="10" rx="1" fill="#DBEAFE" />
      <circle cx="30" cy="25" r="3" fill="#60A5FA" />
      <path d="M36 23 L40 27 L36 31" stroke="#2563EB" strokeWidth="1.5" fill="none" />
      <ellipse cx="18" cy="38" rx="4" ry="3" fill="#1E40AF" />
      <ellipse cx="46" cy="38" rx="4" ry="3" fill="#1E40AF" />
      <ellipse cx="32" cy="42" rx="4" ry="3" fill="#1E3A8A" />
    </svg>
  );
}

export function ChannelEmailIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M10 22 L32 38 L54 22" stroke="#86EFAC" strokeWidth="3" fill="none" />
      <path d="M8 20 L32 6 L56 20 L56 48 L8 48 Z" fill="#DCFCE7" stroke="#22C55E" strokeWidth="2" />
      <path d="M8 20 L32 36 L56 20" fill="#BBF7D0" />
      <rect x="20" y="28" width="24" height="16" rx="2" fill="#F0FDF4" stroke="#16A34A" strokeWidth="1.5" />
      <line x1="24" y1="33" x2="40" y2="33" stroke="#86EFAC" strokeWidth="1.5" />
      <line x1="24" y1="37" x2="36" y2="37" stroke="#86EFAC" strokeWidth="1.5" />
    </svg>
  );
}

export function ChannelChatIcon() {
  return (
    <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M8 16 L8 40 L16 40 L22 48 L22 40 L40 40 L40 16 Z" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="2" />
      <circle cx="18" cy="28" r="2.5" fill="#F59E0B" />
      <circle cx="24" cy="28" r="2.5" fill="#F59E0B" />
      <circle cx="30" cy="28" r="2.5" fill="#F59E0B" />
      <path d="M24 32 L24 52 L32 44 L52 44 L52 24 L32 24 L24 32 Z" fill="#FFF" stroke="#3B82F6" strokeWidth="2" />
      <circle cx="36" cy="34" r="2" fill="#3B82F6" />
      <circle cx="42" cy="34" r="2" fill="#3B82F6" />
      <circle cx="48" cy="34" r="2" fill="#3B82F6" />
    </svg>
  );
}

export function ChannelLightbulbIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10 2a5 5 0 0 0-3 9.1V13h6v-1.9A5 5 0 0 0 10 2Z"
        fill="#FDE68A"
        stroke="#F59E0B"
        strokeWidth="1.2"
      />
      <rect x="7" y="13" width="6" height="2" rx="1" fill="#94A3B8" />
      <rect x="8" y="15.5" width="4" height="1.5" rx="0.5" fill="#CBD5E1" />
    </svg>
  );
}

const ICON_BY_ID = {
  meeting: ChannelMeetingIcon,
  email: ChannelEmailIcon,
  chat: ChannelChatIcon,
};

export function ChannelOptionIcon({ id }) {
  const Icon = ICON_BY_ID[id];
  return Icon ? <Icon /> : null;
}
